import { render, staticRenderFns } from "./Orderdetails.vue?vue&type=template&id=f2ca9fa4&scoped=true&"
import script from "./Orderdetails.vue?vue&type=script&lang=js&"
export * from "./Orderdetails.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetails.vue?vue&type=style&index=0&id=f2ca9fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ca9fa4",
  null
  
)

export default component.exports